import React from 'react';
import Balance from './BalanceC';
import Charty from './ChartC';

const Main = () => { 
  return (
    <main className='main'>
        <Balance />
        <Charty />
    </main>
  )
}

export default Main